import React from 'react';
import { Col } from 'react-bootstrap';
import Icon from '@/ui/assets/Icon';
import { useScreenSize } from '@/ui/hooks/useScreenSize';
import type { ScreenSize } from '@/ui/hooks/useScreenSize';

interface ContactItemProps {
    /** Nombre del icono a mostrar */
    iconName: string;
    /** Clase de icono */
    iconClass?: string;
    /** Título del elemento de contacto */
    title: string;
    /** Clase del título */
    titleClass?: string;
    /** Título personalizado (ReactNode) */
    customTitle?: React.ReactNode;
    /** Contenido de texto (opcional) */
    content?: string;
    /** Clase del contenido */
    childrenClass?: string;
    /** Tamaño del icono */
    size?: number;
    /** Contenido opcional personalizado */
    children?: React.ReactNode;
    /** Clases CSS adicionales */
    className?: string;
    /** Función de click */
    onClick?: () => void;
}

/**
 * Componente para mostrar un ítem de contacto con su icono y contenido
 */
const ContactItem: React.FC<ContactItemProps> = ({
    iconName,
    iconClass,
    title,
    titleClass,
    childrenClass,
    customTitle,
    content,
    size = 24,
    children,
    className = '',
    onClick
}) => {
    /** Hook que contiene las dimensiones de la pantalla y maneja los componentes de acuerdo al resultado obtenido */
    const { width, maxLargeWidth }: ScreenSize = useScreenSize();

    /** Variable que define si es entorno mobile o desktop */
    const isMobile: boolean = width < maxLargeWidth;

    return (
        <>
            {isMobile ? (
                <Col className={`d-flex pt-3 ${className}`} onClick={onClick} style={onClick ? { cursor: 'pointer' } : {}}>
                    <Col xs={1} className='d-flex align-items-start text-secondary-2 '>
                        <Icon name={iconName} size={size} classMain={`${iconClass}`} />
                    </Col>
                    <Col xs={11} className={`d-flex flex-column justify-content-start align-items-start ${childrenClass}`}>
                        {customTitle || <span className={`paragraph fw-bold ps-2 ${titleClass}`}>{title}</span>}
                        {content && <span className='text-secondary-2 ps-2'>{content}</span>}
                        {children}
                    </Col>
                </Col>
            ) : (
                <Col className={`mt-3 ps-3 d-flex flex-row ${className}`} onClick={onClick} style={onClick ? { cursor: 'pointer' } : {}}>
                    <Col xs={1} lg={1} className='d-flex align-items-start text-secondary-2'>
                        <Icon name={iconName} size={size} classMain={`${iconClass}`} />
                    </Col>
                    <Col xs={11} lg={11} className={`d-flex flex-column  ${childrenClass}`}>
                        {customTitle || <span className={`paragraph fw-bold pb-1 ${titleClass}`}>{title}</span>}
                        {content && <span className='text-secondary-2'>{content}</span>}
                        {children}
                    </Col>
                </Col>
            )}
        </>
    );
};

export default ContactItem;